// Los cinco KPIs de Promos venta en la barra común; los calcula el back sobre las promos no archivadas.
import { KpiBar } from '@/shared/patterns/KpiBar';
import type { SalePromotionKpis } from '../api/promotionsContract';
import { SALE_PROMOTION_HELP } from '../constants/helpText';
import { formatBudgetUsed, formatInt } from '../lib/promotionsFormat';

interface KpiCard {
    label: string;
    value: string;
    hint?: string;
    help: string;
}

function kpiCards(kpis: SalePromotionKpis | undefined): KpiCard[] {
    const value = (n: number | undefined) => (n === undefined ? '—' : formatInt(n));
    return [
        {
            label: 'Activas',
            value: value(kpis?.activeCount),
            hint: kpis ? `${formatInt(kpis.expiringIn7DaysCount)} vencen ≤ 7d` : undefined,
            help: SALE_PROMOTION_HELP.kpiActive,
        },
        {
            label: 'Programadas',
            value: value(kpis?.scheduledCount),
            hint: 'arrancan próximamente',
            help: SALE_PROMOTION_HELP.kpiScheduled,
        },
        {
            label: 'Pausadas',
            value: value(kpis?.pausedCount),
            hint: 'reanudar o vencer',
            help: SALE_PROMOTION_HELP.kpiPaused,
        },
        {
            label: 'Canjes 30d',
            value: value(kpis?.redemptionsLast30Days),
            hint: 'promos activas del último mes',
            help: SALE_PROMOTION_HELP.kpiRedemptions,
        },
        {
            label: 'Presupuesto usado',
            value: kpis ? formatBudgetUsed(kpis.budgetUsedBps) : '—',
            hint: 'consumo total sobre topes activos',
            help: SALE_PROMOTION_HELP.kpiBudgetUsed,
        },
    ];
}

export function PromotionsKpiBar({ kpis }: { kpis: SalePromotionKpis | undefined }) {
    return (
        <KpiBar
            items={kpiCards(kpis).map((card) => ({
                label: card.label,
                value: card.value,
                sub: card.hint,
                help: card.help,
            }))}
        />
    );
}
